import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";

import { OUT_OF_FREQUENCY_ENTITY_TYPES } from "@app/scene/dashboard/components/cards/OutOfFrequency/consts";
import OutOfFrequencyCardConfiguration from "@app/types/dashboard/cards/outOfFrequency/OutOfFrequencyCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

const createMapViewStateFromConfiguration = (
  { criteria }: OutOfFrequencyCardConfiguration,
  scope: Scope
): Partial<MapViewState> => ({
  filter: {
    universal: {
      cadenceDaysOut: { operator: FilterOperator.IS_OVERDUE, value: undefined },
      ...(criteria.sources.length
        ? {
            sourceCreated: {
              operator: FilterOperator.IN_ANY,
              value: criteria.sources,
            },
          }
        : {}),
      ...(scope.teamId && !scope.userId
        ? {
            team: {
              operator: FilterOperator.IN_ANY,
              value: [scope.teamId],
            },
          }
        : {}),
      ...(scope.userId
        ? {
            user: {
              operator: FilterOperator.IN_ANY,
              value: [scope.userId],
            },
          }
        : {}),
    },
  },
  visibleEntities: criteria.entityTypes.length
    ? criteria.entityTypes
    : [...OUT_OF_FREQUENCY_ENTITY_TYPES],
});

export default createMapViewStateFromConfiguration;
